import { COST_CENTERS } from "..";
import { apiInstance } from "../config/apiInstance";

export type PostCostCenterRequest = {
  code: string;
  name: string;
  description: string;
  accountingAccount: string;
  conceptCode: string;
  fundingSource: string;
  stateId: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
};

export type PostCostCenterState = {
  id: number;
  code: string;
  name: string;
};

export type PostCostCenterHealthServiceProvider = {
  id: number;
  code: string;
  employerIdNumber: string;
  name: string;
  creditor: string;
};

export type PostCostCenterResponse = {
  id: number;
  code: string;
  name: string;
  description: string;
  accountingAccount: string;
  conceptCode: string;
  fundingSource: string;
  state: PostCostCenterState;
  effectiveStartDate: string;
  effectiveEndDate: string;
};

export const postCostCenter = async (
  data: PostCostCenterRequest,
): Promise<PostCostCenterResponse> => {
  const response = await apiInstance.post<PostCostCenterResponse>(
    COST_CENTERS,
    data,
  );
  return response.data;
};
